import 'normalize.css'
import '@/assets/scss/app.scss'
import '@/assets/scss/transition.scss'
import '@/assets/iconfont/iconfont.js' // 系统彩色图标
import '@/assets/iconfont/iconfont.css' // 系统图标
import '@/assets/fileicon/iconfont.css' // 系统图标
import '@/assets/fileicon/iconfont.js' //  系统彩色图标
import setupElementPlus from './elementPlus'
import setupWindow from './window'
import setupContextMenu from './contextMenu'
import setupDirectives from './directives.js'
import { ColorPicker } from 'vue-color-kit'
import 'vue-color-kit/dist/vue-color-kit.css'
import vueDanmaku from 'vue3-danmaku';
const setupPlugin = (app) => {
  setupWindow()
  setupDirectives(app)
  setupElementPlus(app)
  setupContextMenu(app)
  app.component("vue-danmaku",vueDanmaku)
  app.component('ColorPicker', ColorPicker)
}

export default setupPlugin
